<template>
    <personalities-card/>
    <personalities-science-interests/>
    <personalities-science-achievements/>
    <personalities-significant-research/>
    <personalities-main-publications/>
    <personalities-media-publications/>
    <personalities-settings/>
</template>
<script>

import PersonalitiesCard from '@/components/personalities/PersonalitiesCard.vue'
import PersonalitiesScienceInterests from '@/components/personalities/PersonalitiesScienceInterests.vue'
import PersonalitiesScienceAchievements from '@/components/personalities/PersonalitiesScienceAchievements.vue'
import PersonalitiesSignificantResearch from '@/components/personalities/PersonalitiesSignificantResearch.vue'
import PersonalitiesMainPublications from '@/components/personalities/PersonalitiesMainPublications.vue'
import PersonalitiesMediaPublications from '@/components/personalities/PersonalitiesMediaPublications.vue'
import PersonalitiesSettings from '@/components/personalities/PersonalitiesSettings.vue'

import {useRoute} from 'vue-router'
import {useUserStore} from '@/store/user';
import {useAuthStore} from '@/store/auth';

export default{
    name: 'HomePage',
    components: {
        PersonalitiesCard,
        PersonalitiesScienceInterests,
        PersonalitiesScienceAchievements,
        PersonalitiesSignificantResearch,
        PersonalitiesMainPublications,
        PersonalitiesMediaPublications,
        PersonalitiesSettings
    },
    methods:{
        async updateUser(){
            let UserStore = useUserStore()
            await UserStore.updateUser()
        }
    },
    async mounted(){
        const userStore = useUserStore()
        let route = useRoute()
        const route_id = route.params.id
        await userStore.getUser(route_id)
        const authStore = useAuthStore()
        const router = this.$router
        if (!userStore.changeUser.email){
            router.push({"name": 'ErrorPage'})
        }
        if (!(authStore.permissions.indexOf("personalities")> -1 || 
        userStore.changeUser.show_personality || 
        userStore.changeUser.email == authStore.email)){
            router.push({"name": 'ErrorPage'})
        }
    },
    async beforeCreate(){

    }
}
</script>